<template>
  <div class="nav">
    <div class="container">
      <div class="left">
        <div class="logo" @click="toHome">
          <img class="logo" src="@/assets/images/logo.jpg" alt="logo" />
        </div>
        <div class="menu">
          <ul>
            <li
              :class="[
                'menu-item',
                {
                  'menu-item-active': activeNav === 'home'
                }
              ]"
              @click="toHome"
            >
              首页
            </li>
            <li
              :class="[
                'menu-item',
                {
                  'menu-item-active': activeNav === 'register'
                }
              ]"
              @click="toRegister"
            >
              报名参赛
            </li>
            <li
              :class="[
                'menu-item',
                {
                  'menu-item-active': activeNav === 'register'
                }
              ]"
              @click="toNews"
            >
              大赛动态
            </li>
            <li
              :class="[
                'menu-item',
                {
                  'menu-item-active': activeNav === 'register'
                }
              ]"
              @click="toInterview"
            >
              大赛专栏
            </li>
            <li
              :class="[
                'menu-item',
                {
                  'menu-item-active': activeNav === 'register'
                }
              ]"
              @click="toGuide"
            >
              投稿指南
            </li>
            <li
              :class="[
                'menu-item',
                {
                  'menu-item-active': activeNav === 'collections'
                }
              ]"
              @click="toCollections"
            >
              历届作品
            </li>
            <li
              :class="[
                'menu-item',
                {
                  'menu-item-active': activeNav === 'experts'
                }
              ]"
              @click="toExperts"
            >
              专家库
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <span
          :class="{
            'right-active': lang === 'cn'
          }"
          @click="changeLang('cn')"
        >
          中文
        </span>
        <span>/</span>
        <span
          :class="{
            'right-active': lang === 'en'
          }"
          @click="changeLang('en')"
        >
          En
        </span>
        <!-- <el-dropdown>
          <el-button type="text">
            {{ $t('global.change-language') }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="lang !== 'cn'">
              <el-button
                type="text"
                style="width: 100%; text-align: center"
                size="small"
                @click="changeLang('cn')"
              >
                {{ $t('global.language-cn') }}
              </el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="lang !== 'en'">
              <el-button
                type="text"
                style="width: 100%; text-align: center"
                size="small"
                @click="changeLang('en')"
              >
                {{ $t('global.language-en') }}
              </el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
  </div>
</template>

<script>
import { localStore } from '@/utils/store'
import * as ConstantRouter from '@/constant/router'
import { newWindowOpen } from '@/utils/tools'

export default {
  props: ['activeNav'],
  data() {
    return {
      jsId: this.$route.params.jsId,
      lang: localStore.get('lang') || 'cn' // 语言标识
    }
  },
  async mounted() {
    if (!this.jsId) {
      this.jsId = await this.fetchList()
    }
  },
  methods: {
    async fetchList(pageIndex = 1) {
      const [err, res] = await this.$serve.jsRecord.getPageList({
        data: { pageIndex }
      })
      if (err) return
      return res.records[0].id
    },
    toHome() {
      this.$router.push({
        name: ConstantRouter.EVENT
      })
    },
    toRegister() {
      newWindowOpen({
        name: ConstantRouter.COMPETITOR_LOGIN,
        params: {
          jsId: this.jsId
        }
      })
    },
    toNews() {
      if (this.$route.name === ConstantRouter.EVENT) {
        document
          .getElementById('index-news')
          ?.scrollIntoView({ behavior: 'smooth' })
        return
      }

      this.$router.push({
        name: ConstantRouter.EVENT
      })
    },
    toInterview() {
      if (this.$route.name === ConstantRouter.EVENT) {
        document
          .getElementById('index-interview')
          ?.scrollIntoView({ behavior: 'smooth' })
        return
      }

      this.$router.push({
        name: ConstantRouter.EVENT
      })
    },
    toGuide() {
      newWindowOpen({
        name: ConstantRouter.GUIDE,
        params: {
          jsId: this.jsId
        }
      })
    },
    toCollections() {
      this.$router.push({
        name: ConstantRouter.COLLECTIONS
      })
    },
    toExperts() {
      this.$router.push({
        name: ConstantRouter.EXPERTS
      })
    },
    changeLang(lang) {
      if (lang === this.lang) {
        return
      }
      localStore.set('lang', lang)
      location.reload()
    }
  }
}
</script>

<style lang="scss">
.nav {
  .container {
    width: 1320px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .left {
    display: flex;
    align-items: center;
    gap: 50px;
  }

  .right {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
    color: #888;

    span {
      cursor: pointer;
    }
  }

  .logo {
    width: 140px;
  }

  .menu {
    ul {
      display: flex;
      gap: 10px;
    }

    li {
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      padding: 10px 30px;
      border-radius: 4px;
      transition: all 0.4s;
      color: #333;

      &:hover {
        color: rgba(174, 137, 74, 1);
      }
    }

    .menu-item-active {
      color: rgba(174, 137, 74, 1);
    }
  }

  .right-active {
    color: #000;
  }
}
</style>
